import {AgentReference} from "../../../agents/angular/models/agentReference.model";
import {BranchReference} from "./timecard.model";
import {TimeCardModel} from "./timecard.model";
import {TimeCardGroupStatus} from "../../types/timecard-group-status.enum";

export {TimeCardGroupStatus};

export interface TimeCardDataTotals {
  totalEntriesCount: number;
  totalStopsCount: number;
  totalBreaksCount: number;
  totalDistanceMeter: number;
  totalTravelTimeDurationMillis: number;
  totalServiceTimeDurationMillis: number;
  totalBreakDurationMillis: number;
  totalTimeMillis: number;
  speedKmh: number;
  /** @deprecated Being removed from API — derive from speedKmh */
  speedMph?: number;
  /** @deprecated Being removed from API — derive from totalDistanceKilometers */
  totalDistanceMiles?: number;
  totalDistanceKilometers: number;
}

export interface TimeCardGroupTotals {
  totalTimeCardCount: number;
  plannedTotals: TimeCardDataTotals;
  reportedTotals: TimeCardDataTotals;
  totalAdminTime?: number;
}

export interface TimeCardGroup {
  id: string;
  agentId: string;
  status: TimeCardGroupStatus;
  startTime: number; // Timestamp from Java Date
  endTime: number; // Timestamp from Java Date
  agentReference: AgentReference;
  branchIds: string[];
  branchReferences: BranchReference[];
  totals: TimeCardGroupTotals;
  timeCards: TimeCardModel[];
}
